export interface UrlAdaptOptions {
    search?: {
        [key: string]: string
    }
}

export type DocumentUrlType =
    | 'simple-product'
    | 'product'
    | 'substitution'
    | 'document'
    | 'faq';

export interface DocumentUrlMapData {
    type: DocumentUrlType
    pattern: string
}

const MAP_CONFIG: { [key: string]: DocumentUrlMapData } = {
  '/product/': {
    type: 'simple-product',
    pattern: '/catalogBrowse/{part1}',
  },
  '/product-category/': {
    type: 'product',
    pattern: '/catalogBrowse/{part1}/category/{part2}',
  },
  '/product-range/': {
    type: 'product',
    pattern: '/catalogBrowse/{part1}/range/{part2}',
  },
  '/product-subcategory/': {
    type: 'product',
    pattern: '/catalogBrowse/{part1}/subcategory/{part2}',
  },
  '/product-substitution/': {
    type: 'substitution',
    pattern: '/productSubsTool?search={part1}',
  }
};

function urlAdaption(url: string, options?: UrlAdaptOptions): string {
    return (
      window.origin +
        '/myschneider' +
        url +
        (options?.search
          ? `?${new URLSearchParams(options?.search).toString()}`
          : '')
    );
}

function mapUrlByCategory(urlValue: string): string {
    const clearUrlValue = urlValue
      .replace('https://www.se.com/', '')
      .replace('www.se.com/', '');

    let documentUrlMapData: DocumentUrlMapData,
      partial: string,
      part1: string,
      part2: string;

    Object.keys(MAP_CONFIG).forEach((keyPartial) => {
        if (clearUrlValue.includes(keyPartial)) {
          documentUrlMapData = MAP_CONFIG[keyPartial];
          partial = keyPartial;
        }
    });

    if (!documentUrlMapData) {
      return urlValue;
    }

    [part1, part2] = clearUrlValue.split(partial);

    switch (documentUrlMapData.type) {
    case 'simple-product':
      part1 = clearUrlValue;
      break;
    case 'substitution':
      part1 = part2;
      break;
    case 'faq':
      const lang = part1.split('/')[0];
      part1 = part2;
      part2 = lang;
      break;
    case 'product':
      part2 = part2.split('-')[0];
      break;
    }

    return urlAdaption(
      documentUrlMapData.pattern
        .replace('{part1}', part1)
        .replace('{part2}', part2)
    );
}

function iterateAndMapURLs(results) {
    results.forEach(doc => {
        doc.openUrl = doc.openUrl ? mapURL(doc.openUrl) : undefined;
        if (doc.subLevels && doc.subLevels.length > 0) {
          iterateAndMapURLs(doc.subLevels);
        }
    });

    return results;
}

function mapURL(urlValue) {
    if (urlValue.includes('www.clipsal.com')) {
      return urlValue;
    }
    return mapUrlByCategory(urlValue);
}


function conversationalSearchProductsMap(documents) {
    return iterateAndMapURLs(documents);
}

export default conversationalSearchProductsMap;
